
<div class="modal-body-message-template-quote">
  <div
    class="modal-body-message-template-quote-tabs btn-group d-flex mb-3"
    data-toggle="btns"
    role="group"
  >
    <a
      v-for="index in 5"
      :key="`title_${index}`"
      class="btn btn-lg btn-info modal-tab-btn w-100"
      role="button"
      data-toggle="tab"
      :href="'#tab-message-description' + index"
      :class="{ active: index === selected_tab }"
      @click="selected_tab = index"
      >{{ titles[index - 1] }}
    </a>
  </div>
  <div class="modal-body-message-template-quote-tab-content tab-content">
    <div
      v-for="index in 5"
      :id="'tab-message-description' + index"
      :key="`message_${index}`"
      class="tab-pane"
      role="tabpanel"
      :class="{ active: index === selected_tab }"
    >
      <label
        v-for="index2 in description[index - 1].length"
        :key="`description_${index2}`"
        class="modal-template-item"
      >
        <input
          id="radio01"
          type="radio"
          class="modal-template-radio-input"
          name="radio01"
          @click="quote(index, index2)"
        />
        <p class="modal-template-radio-parts d-flex align-items-center">
          <i class="fa fa-check-circle fa-lg" />
          <span v-html="description[index - 1][index2 - 1].replace(/\n/g, '<br/>')" />
        </p>
      </label>
    </div>
  </div>
</div>
